import { AppRouter } from './router';

function App() {
  return <AppRouter />;
}

export { App };
